// AppLayout.tsx
import { FloatingChatButton } from "@/components/chat/FloatingChatButton";
import { HeaderBar3 } from "@/components/page/HeaderBar3";
import { PageProvider } from "@/components/page/PageContext";
import { ReportForceBar } from "@/components/page/ReportForceBar";
import { AppSidebar } from "@/components/sidebar/AppSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/toaster";
import { useAirport } from "@/stores/AirportContext";
import { useReportContext } from "@/stores/ReportContext";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";

interface AppLayoutProps {
  enableForceBar?: boolean;
}

const NoReportState: React.FC = () => {
  const { isLoading } = useReportContext();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="mx-4 mt-6 rounded-lg border border-gray-700 bg-gray-900 p-6 text-gray-100">
      <h2 className="text-2xl font-semibold text-white">
        No report available yet
      </h2>
      <p className="mt-2 text-sm text-gray-300">
        This airport does not have a ready live report yet. You can switch to a
        different airport from the header, or wait for the next forecast run to
        complete.
      </p>
    </div>
  );
};

const ReportContentGate: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { hasReport } = useReportContext();

  if (!hasReport) {
    return <NoReportState />;
  }

  return <>{children}</>;
};

const AppLayout: React.FC<AppLayoutProps> = ({ enableForceBar = true }) => {
  const { aiChatEnabled } = useAirport();
  const location = useLocation();
  const uiContext = {
    current_page: location.pathname
  };
  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="w-full">
        <PageProvider>
          <HeaderBar3></HeaderBar3>
          <ReportForceBar />
          <div className="p-2 md:p-4">
            <ReportContentGate>
              <Outlet />
            </ReportContentGate>
          </div>
        </PageProvider>
      </main>
      {aiChatEnabled && <FloatingChatButton uiContext={uiContext} />}
      <Toaster />
    </SidebarProvider>
  );
};

export default AppLayout;
